'use client';

import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import Button from '@edgevanta/ui/components/button';

const localStorageKey = 'maintenance-banner-dismissed';

type MaintenanceBannerProps = {
  text: string | undefined;
};

export default function MaintenanceBanner({ text }: MaintenanceBannerProps) {
  const [isDismissed, setIsDismissed] = useLocalStorage(localStorageKey, false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  if (isDismissed) {
    return null;
  }

  return (
    <div className="px-4 py-2 flex items-center justify-center space-x-2">
      <span className="text-sm">{text}</span>

      <Button
        className="cursor-pointer"
        onClick={() => setIsDismissed(true)}
        size="sm"
      >
        Close
      </Button>
    </div>
  );
}
